exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._--8f5AE2qySW5BUDqsFF8{padding-top:20px}", ""]);

// exports
exports.locals = {
	"userVoiceDisclaimerLabel": "_--8f5AE2qySW5BUDqsFF8"
};